module.exports = __webpack_public_path__ + "img/VOLVO.d50992b.jpg";